import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ActiveSecurityContextStateService } from '@auth/active-security-context.state-service';
import { LoggingService } from '@logging/logging.service';

/**
 * Prevents users accessing views that are for unauthenticated users only e.g. the login form.
 * Redirects to the dashboard if accessed.
 */
@Injectable({ providedIn: 'root' })
export class AnonymousRouteGuard {
  constructor(
    private activeSecurityStateContext: ActiveSecurityContextStateService,
    private logger: LoggingService
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (AnonymousRouteGuard.isAuthForbiddenView(state.url)) {
      return of(true);
    }
    if (this.activeSecurityStateContext.ensureUnityAccess()) {
      this.activeSecurityStateContext.redirectToBestRoute();
      return of(false);
    } else {
      this.logger.trace('AnonymousRouteGuard: Allowing unauthenticated access to auth route.');
      return of(true);
    }
  }

  /** Matches navigation to {@link PermissionRouteGuard} forbidden URL `/auth/403`. */
  private static isAuthForbiddenView(url: string): boolean {
    return /^\/auth\/403(\?|\/|$)/.test(url);
  }
}